import { render, staticRenderFns } from "./Journey.vue?vue&type=template&id=4219fd5e&"
import script from "./Journey.vue?vue&type=script&lang=js&"
export * from "./Journey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports